module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-three5.5b5d406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-three5.png
// module id = /uH1
// module chunks = 0